import React from 'react';

interface DataSummaryProps {
  summary: {
    rows: number;
    columns: number;
    column_names: string[];
    head: any[];
  };
}

const DataSummary: React.FC<DataSummaryProps> = ({ summary }) => (
  <div style={{ width: '100%', marginBottom: 32, maxWidth: 900, marginLeft: 'auto', marginRight: 'auto', background: '#f9f9f9', borderRadius: 10, boxShadow: '0 1px 8px rgba(0,0,0,0.04)', border: '1.5px solid #e0e0f0', padding: '24px 0 18px 0' }}>
    <h2 style={{ fontSize: 22, margin: '0 0 18px 0', color: '#2a2a4a', fontWeight: 700, letterSpacing: 0.2, textAlign: 'center', textShadow: '0 1px 0 #fff' }}>Data Summary</h2>
    <div style={{ display: 'flex', gap: 48, justifyContent: 'center', marginBottom: 14, fontSize: 16, color: '#2a2a4a', fontWeight: 600 }}>
      <div style={{ background: '#e0e0f8', borderRadius: 7, padding: '8px 22px', border: '1.5px solid #b0b6c3', minWidth: 90, textAlign: 'center', boxShadow: '0 1px 4px rgba(0,0,0,0.03)' }}>
        <span style={{ color: '#2a2a4a' }}>Genes</span><br />
        <span style={{ fontSize: 18, fontWeight: 700 }}>{summary.rows}</span>
      </div>
      <div style={{ background: '#e0e0f8', borderRadius: 7, padding: '8px 22px', border: '1.5px solid #b0b6c3', minWidth: 90, textAlign: 'center', boxShadow: '0 1px 4px rgba(0,0,0,0.03)' }}>
        <span style={{ color: '#2a2a4a' }}>Sample Groups</span><br />
        <span style={{ fontSize: 18, fontWeight: 700 }}>{summary.columns}</span>
      </div>
    </div>
    <div style={{ fontSize: 15, color: '#444', marginBottom: 0, textAlign: 'center', background: '#f7fbff', borderRadius: 7, padding: '10px 18px', border: '1.5px solid #e0e0f0', maxWidth: 700, margin: '0 auto', boxShadow: '0 1px 4px rgba(0,0,0,0.02)' }}>
      <b>Sample Group Names:</b> {summary.column_names.join(', ')}
    </div>
  </div>
);

export default DataSummary;
